const model = {
    seasonDetails: null,
    loading: false,
    error: null,
};

export default model;
